<template>
  <v-app :style="'height:100%;background-image:url(' + bg + ');background-size:cover;'">

    <v-dialog
            v-model="dialog_error"
            max-width="800"
            style
        >   <v-card class="pa-8">
            <v-icon class="text-h1" color="red">mdi-close</v-icon>
            <div class="text-h6 mt-4"><b>การจองไม่สำเร็จ</b></div>
            <div class="text-h7 mt-4">{{ error_text_1 }}</div>
            <div class="text-h7 mt-4">{{ error_text_2 }}</div>
            <div class="text-center mt-16">
                <v-btn outlined style="color:black" rounded color="grey" @click="dialog_error=false">
                <v-icon left>mdi-close</v-icon>ปิด</v-btn>
            </div>
            </v-card>
        </v-dialog>
  
    <div style="height:9%;"></div>
    <div style="background-color: white;height:85%;/*box-shadow: 0px -4px 0px #000000;*/">

        <div v-if="selecting_tag=='confirm'" class="text-h5 mt-8 mb-4">
          {{ $t('reservation_confirm_title') }}
        </div>

        <div v-if="selecting_tag=='confirmed'" class="text-h5 mt-8 mb-4">
          {{ $t('reservation_confirmed_title') }}
          <v-btn tile color="error" @click="close" class="ml-16">
              <v-icon left>mdi-close</v-icon>{{ $t('Close') }}
          </v-btn>
        </div>

        <!--<v-row :style="'background-image:url(' + banner + ');height:90px;background-size: cover;width:100%;margin-left:0px;'">
            <v-col cols="3" class="pl-9">
                <v-img :src="logo" min-width="60" contain />
            </v-col>
            <v-col cols="9" align="left" class="text-h6">
                {{ station_name }}
            </v-col>
        </v-row>-->

        <div align="left" class="pa-8"> 

          <div v-if="selecting_tag=='group'">
              <FragmentSelectGroup
                :nextstep="nextstep"            
              ></FragmentSelectGroup>
          </div>

          <div v-if="selecting_tag=='date'">
              <FragmentSelectDate
                :nextstep="nextstep"              
              ></FragmentSelectDate>
          </div>

          <div v-if="selecting_tag=='time'">
              <FragmentSelectTime
                :nextstep="nextstep"              
              ></FragmentSelectTime>
          </div>
          <div v-if="selecting_tag=='datetime'">
              <FragmentSelectDateTime
                :nextstep="nextstep"              
              ></FragmentSelectDateTime>
          </div>

          <div v-if="selecting_tag=='extranote'">
              <FragmentSelectExtranote
                :nextstep="nextstep"              
              ></FragmentSelectExtranote>
          </div>

          <div v-if="selecting_tag=='confirm'||selecting_tag=='confirmed'">
              <FragmentConfirm
                :nextstep="nextstep"              
              ></FragmentConfirm>
          </div>
        

          <div v-if="selecting_tag=='confirmed' && group_extranote.length > 0" style="border: 1px solid green;height:120px;overflow: scroll;" class="pa-4 mt-4 mb-8">
            <div><b>หมายเหตุ :</b></div>
            <div>{{ group_extranote }}</div>
          </div>

        </div>

        <div v-if="selecting_tag=='confirm'" align="center" style="position: absolute;bottom: 10%;width:100%;">
          <v-btn  color="#00E4FF" class="pa-5 text-h5 ma-2" width="80%" @click="confirm" :disabled="!valid">
            {{ $t('reservation_confirm_btn') }}
          </v-btn>
        </div>

        <div v-if="selecting_tag=='confirmed'" class="text-h6" align="center" style="position: absolute;bottom: 15%;width:100%;">
            {{ $t('reservation_confirmed_accept_by_' + $route.params.reserve_accept_by) }}
        </div>

    </div>
  </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import App from '@/models/instance/App'
import AppointmentSelection from '@/models/instance/AppointmentSelection'
import FragmentSelectGroup from '@/components/AppointmentNew/FragmentSelectGroup.vue'
import FragmentSelectDate from '@/components/AppointmentNew/FragmentSelectDate.vue'
import FragmentSelectTime from '@/components/AppointmentNew/FragmentSelectTime.vue'
import FragmentSelectDateTime from '@/components/AppointmentNew/FragmentSelectDateTime.vue'
import FragmentSelectExtranote from '@/components/AppointmentNew/FragmentSelectExtranote.vue'
import FragmentConfirm from '@/components/AppointmentNew/FragmentConfirm.vue'

import axios from 'axios';
import config from '@/../config.js'
import Member from '@/models/instance/Member'

export default {
  components: {
    FragmentSelectGroup
    ,FragmentSelectDate
    ,FragmentSelectTime
    ,FragmentConfirm
    ,FragmentSelectDateTime
    ,FragmentSelectExtranote
  },
  data () {
    return {
      station_name:""
      //,logo: require('@/assets/logo-default.jpg')
      //,banner: require('@/assets/banner-default.jpg')
      ,bg : ""
      ,selecting_tags : ['group','date','time']
      ,valid : true
      ,dialog_error : false
      ,error_text_1 : ""
      ,error_text_2 : ""
      ,group_extranote : ""
    }
  },
  computed : {
    selecting_tag () { 
      if(this.$route.params.step_id == this.selecting_tags.length + 1){
        return "confirm"
      }if(this.$route.params.step_id == this.selecting_tags.length + 2){
        return "confirmed"
      }else{
        return this.selecting_tags[this.$route.params.step_id - 1]
      }
    }
  },
  mounted : function () {
    if(JSON.parse(AppointmentSelection.getExtranote()).length>0){
      this.selecting_tags = ['group','date','time','extranote']
    }else{
      AppointmentSelection.setExtranoteValue(JSON.stringify([]))
      this.selecting_tags = ['group','date','time']
    }
    if(this.$route.query.custompage != undefined){
        if(this.$route.query.custompage!=undefined
            && config['custompage']!=undefined
            && config['custompage'][App.getAppId()]!=undefined
            && config['custompage'][App.getAppId()][this.$route.query.custompage]!=undefined 
            && config['custompage'][App.getAppId()][this.$route.query.custompage]['page']=='date'
            && config['custompage'][App.getAppId()][this.$route.query.custompage]['group']!=undefined){
          AppointmentSelection.setGroupId(config['custompage'][App.getAppId()][this.$route.query.custompage]['group'])
          this.nextstep()
      } 
    }
    /*this.bg = App.getAppConfigBackgroud()
    this.station_name = AppointmentSelection.getStationName()
    if(AppointmentSelection.getLogo().length > 0) this.logo = AppointmentSelection.getLogo()
    if(AppointmentSelection.getBanner().length > 0) this.banner = AppointmentSelection.getBanner()*/
  },
  methods : {
    close(){
      window.location.href = AppointmentSelection.getAddfriendUrl()
    },
    nextstep(){
      if(JSON.parse(AppointmentSelection.getExtranote()).length>0){
        this.selecting_tags = ['group','date','time','extranote']
      }else{
        AppointmentSelection.setExtranoteValue(JSON.stringify([]))
        this.selecting_tags = ['group','date','time']
      }
      this.$router.push({name:'AppointmentNewStep',params:{step_id:parseInt(this.$route.params.step_id)+1}})
      this.valid = true
    },
    confirm(){
      var que = this.$store.commit('addLoading')
      axios
      .post(config.api.url.line.appointment.new_confirm
        ,{ 
          station_code:AppointmentSelection.getStationCode()
          ,group_id:AppointmentSelection.getGroupId()
          ,app_id:App.getAppId()
          ,date:AppointmentSelection.getDate()
          ,timestart:AppointmentSelection.getTime()[0]
          ,timeend:AppointmentSelection.getTime()[1]
          ,extranote_list:JSON.parse(AppointmentSelection.getExtranoteValue())
        }
        ,{ headers: Member.getTokenHeader()})
      .then(response => {
          this.$store.commit('finishLoading',que)
          if(response.data.isSuccess){
            AppointmentSelection.reset()
            this.$router.push({name:'AppointmentNewStep',params:{
              step_id:parseInt(this.$route.params.step_id)+1
              ,reserve_accept_by:response.data.reserve_accept_by
            }})
            var que2 = this.$store.commit('addLoading')
            axios
            .post(config.api.url.public.appointment.get_groupshortdetail,{group_id:AppointmentSelection.getGroupId(),lang:'th'})
            .then(response2 => {
              if(response2.data.group_extranote){
                this.group_extranote = response2.data.group_extranote
              }
              this.$store.commit('finishLoading',que2)
            })
          }else{
            var station_name = AppointmentSelection.getStationName()
            var que1 = this.$store.commit('addLoading')
            axios
            .post(config.api.url.public.appointment.get_groupshortdetail,{group_id:AppointmentSelection.getGroupId(),lang:'th'})
            .then(response2 => {
              var group_name = response2.data.group_name
              this.$store.commit('finishLoading',que1)

              this.valid = false
              this.dialog_error = true
              this.error_text_1 = "ลงทะเบียนไม่สำเร็จ"
              if(response.data.err == 'duplicate_duplicate'){
                this.error_text_2 = "มีการจองเดียวกันอยู่แล้ว"
              }else if(response.data.err == 'duplicate_sametime'){
                this.date = AppointmentSelection.getDate()
                var time = AppointmentSelection.getTime()
                var timestartstr = '0000' + time[0];
                timestartstr = timestartstr.substring(timestartstr.length-4,timestartstr.length)
                var timeendstr = '0000' + time[1];
                timeendstr = timeendstr.substring(timeendstr.length-4,timeendstr.length)
                this.error_text_2 = "ช่วง " + timestartstr.substring(0,2) + ':' + timestartstr.substring(2,4) + " - " + timeendstr.substring(0,2) + ':' + timeendstr.substring(2,4) + " จองได้ไม่เกิน " + response.data.duplicate.sametime.split('/')[1] + " ครั้งเท่านั้น"
              }else if(response.data.err == 'duplicate_group_date'){
                this.error_text_2 = group_name + " จองได้ไม่เกิน " + response.data.duplicate.group_date + " ครั้ง/วัน เท่านั้น"
              }else if(response.data.err == 'duplicate_group_week'){
                this.error_text_2 = group_name + " จองได้ไม่เกิน " + response.data.duplicate.group_week + " ครั้ง/สัปดาห์ เท่านั้น"
              }else if(response.data.err == 'duplicate_group_month'){
                this.error_text_2 = group_name + " จองได้ไม่เกิน " + response.data.duplicate.group_month + " ครั้ง/เดือน เท่านั้น"
              }else if(response.data.err == 'duplicate_group_all'){
                this.error_text_2 = group_name + " จองได้ทั้งหมดไม่เกิน " + response.data.duplicate.group_all + " ครั้งเท่านั้น"
              }else if(response.data.err == 'duplicate_station_date'){
                this.error_text_2 = station_name + " ให้จองได้ไม่เกินกว่า " + response.data.duplicate.station_date + " ครั้ง/วัน เท่านั้น"
              }else if(response.data.err == 'duplicate_station_week'){
                this.error_text_2 = station_name + " ให้จองได้ไม่เกินกว่า " + response.data.duplicate.station_week + " ครั้ง/สัปดาห์ เท่านั้น"
              }else if(response.data.err == 'duplicate_station_month'){
                this.error_text_2 = station_name + " ให้จองได้ไม่เกินกว่า " + response.data.duplicate.station_month + " ครั้ง/เดือน เท่านั้น"
              }else if(response.data.err == 'duplicate_station_all'){
                this.error_text_2 = station_name + " ให้จองได้ทั้งสิ้นไม่เกินกว่า " + response.data.duplicate.station_all + " ครั้งเท่านั้น"
              }else{
                this.valid = true
                this.error_text_1 = "Unknow error"
                this.error_text_2 = ""
              }
            })
          }
      })
    }
  },
}
</script>